/**
 * i18n-ready text catalog (Req 22.11) — public surface.
 *
 * The substitution mechanism the auth screens (15.x) and the UserMessage
 * component (14.6) consume: every user-facing string is addressed by a stable
 * {@link MessageId} and resolved against the ACTIVE locale's
 * {@link MessageCatalog} via {@link resolveMessage} / a bound {@link TFunction}.
 * Swapping catalogs swaps the language without changing screen structure/layout.
 *
 * Usage in a component:
 *   const t = useT();
 *   <label>{t("auth.register.emailLabel")}</label>
 *
 * Wrapping the tree (defaults to English; pass a regional catalog to swap):
 *   <I18nProvider catalog={hiMessages} locale="hi"><App /></I18nProvider>
 */

// Catalog type + resolver (framework-agnostic, SSR-safe).
export {
  resolveMessage,
  makeT,
  type MessageId,
  type MessageParams,
  type MessageCatalog,
  type LocaleTag,
  type TFunction,
} from "./catalog.js";

// The English catalog + the derived id union (single source of truth).
export { EN_MESSAGES, type KnownMessageId } from "./messages.js";

// React provider + hooks.
export {
  I18nProvider,
  useMessages,
  useT,
  makeI18nContextValue,
  type I18nProviderProps,
  type I18nContextValue,
} from "./context.js";
